import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

type StaticImageData = {
  src: string;
  height: number;
  width: number;
  blurDataURL?: string;
};

type CardProps = {
  imageSrc: StaticImageData | string;
  chip?: string;
  heading?: string;
  info?: string;
  key: string;
  slug: string;
};

export default function Card(props: CardProps) {
  const { chip, heading, info, imageSrc, slug } = props;

  return (
    <div className="col-lg-4 col-md-6">
      <Link href={`/${slug}` || '#'} className="blogs__card">
        <div className="blogs__card-figures blogs__card-figures-cpy">
          {typeof imageSrc !== 'string' && (
            <Image
              style={{ color: undefined }}
              className="img-fluid"
              src={imageSrc}
              alt={heading || 'blog'}
            />
          )}
          {typeof imageSrc === 'string' && (
            <img className="img-fluid" src={imageSrc} alt="" />
          )}

          {chip && <div className="chips chips--lightBlack">{chip}</div>}
        </div>
        <div className="blogs__card-content card-height">
          <p className="text--black text--bold title">{heading}</p>
          <p className="text--gray text--regular desc smallFont">{info}</p>
        </div>
      </Link>
    </div>
  );
}
